import { render, staticRenderFns } from "./desposit-payment.vue?vue&type=template&id=2ec205b3"
import script from "./desposit-payment.vue?vue&type=script&lang=js"
export * from "./desposit-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports